// src/lib/buttonStyles.js
//
// El botón primario, en un solo sitio.
//
// Estaba escrito de seis formas distintas —`bg-primary`, `bg-primary`,
// `bg-primary`, el degradado violeta→rosa de "Create agent", el
// violeta→morado de "New workflow" y el morado→rosa de Projects— así que la
// misma acción se veía diferente según en qué pantalla cayera.
//
// **Gana el morado sólido, y no por gusto.** El degradado terminaba en
// `pink-500`, y texto blanco sobre `#EC4899` da 3.53:1: la mitad derecha del
// botón —justo donde cae la etiqueta— quedaba por debajo del mínimo AA de
// 4.5. `violet-600` da 5.70, y `violet-700` del hover da 7.10.
//
// El color sale de `--primary` en `input.css`, que es el token que el
// `Button` de shadcn ya usaba. Un botón que no pase por acá vuelve a abrir
// la séptima variante.
export const PRIMARY_BUTTON =
  "bg-primary text-white transition-colors hover:bg-violet-700 " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet-400/60";

// La medida. Los botones de acción salían en tres tamaños distintos —uno a todo
// el ancho, otro como píldora pequeña, otro tan estrecho que partía "Change
// password" en dos líneas— porque cada pantalla elegía su propio padding.
export const BUTTON_SIZE = "h-10 px-5 text-sm font-medium rounded-xl whitespace-nowrap";

export const PRIMARY = `${BUTTON_SIZE} ${PRIMARY_BUTTON}`;
